import React from "react";

export function TravelCarIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="travel-transportation-car--transportation-travel-taxi-transport-cab--Streamline-Core">
        <g id="Group">
          <path
            id="Vector"
            d="M25 21C25.5304 21 26.0391 20.7893 26.4142 20.4142C26.7893 20.0391 27 19.5304 27 19V15C27 14.4696 26.7893 13.9609 26.4142 13.5858C26.0391 13.2107 25.5304 13 25 13H22L20.46 9.52666C20.3208 9.1127 20.05 8.75566 19.6889 8.51009C19.3277 8.26451 18.8961 8.1439 18.46 8.16666H10.44C10.0039 8.1439 9.57227 8.26451 9.21113 8.51009C8.84999 8.75566 8.57916 9.1127 8.44 9.52666L7 13H3C2.46957 13 1.96086 13.2107 1.58579 13.5858C1.21071 13.9609 1 14.4696 1 15V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_2"
            d="M6.99967 22.9166C8.61051 22.9166 9.91634 21.6108 9.91634 20C9.91634 18.3891 8.61051 17.0833 6.99967 17.0833C5.38884 17.0833 4.08301 18.3891 4.08301 20C4.08301 21.6108 5.38884 22.9166 6.99967 22.9166Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_3"
            d="M20.9997 22.9166C22.6105 22.9166 23.9163 21.6108 23.9163 20C23.9163 18.3891 22.6105 17.0833 20.9997 17.0833C19.3888 17.0833 18.083 18.3891 18.083 20C18.083 21.6108 19.3888 22.9166 20.9997 22.9166Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_4"
            d="M11 21H17"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_5"
            d="M12.833 8.16665V5.33331"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
        </g>
      </g>
    </svg>
  );
}
